<!-- eslint-disable max-len -->
<template>
  <div
    class="main-product critical-component-clear"
    :class="{ [$class('loading')]: state === 'loading' }"
  >
    <div class="main-product__container">
      <main-product-sidebar-header
        :is-mobile="isMobile"
        :liquid="liquid"
        :product="product"
        :variant="variant"
        :giftui="giftBlocks"
      />

      <div class="main-product__content">
        <product-gallery
          class="main-product__gallery"
          :current-index="currentIndex"
          :current-namespace="currentNamespace"
          layout="horizontal"
          :product="product || liquid"
          :variant="variant"
          @update-current-index="handleUpdateCurrentIndex"
          @update-current-namespace="handleUpdateCurrentNamespace"
        />
      </div>

      <div
        ref="sidebarWrapper"
        class="main-product__sidebar-wrapper"
      >
        <div
          class="main-product__sidebar"
        >
          <main-product-sidebar-header
            :is-desktop="!isMobile"
            :liquid="liquid"
            :product="product"
            :variant="variant"
            :giftui="giftBlocks"
            @scroll-to-view="scrollToReview"
          />
          <div
            ref="productFormWrapper"
            class="main-product__form"
          >
            <product-form
              ref="productForm"
              :product="product || liquid"
              :variant="variant"
              :quantity-selector="false"
              :giftui="giftBlocks"
              :liquid="liquid"
               :country ="pagecountry"
              :location="pagelocation"
              :section="{
                displaySingleValueOptions: true,
                displaySingleVariantOption: false,
                excludedInitialSelectOptions: [],
                initialSelect: true,
                selectDisabledValues: true,
              }"
              @update-variant="handleVariantUpdate"
              @update-attachment-subtotal="handleAttachmentSubtotalUpdate"
            />
          </div>
          <main-product-sidebar-details
            :liquid="liquid"
            :need-help="contact.needHelp"
            :product="product"
            :variant="variant"
            :usp="uspBlocks"
          />
         
        </div>
        <div v-if="liquid.type == 'sawmill'" class="main-product__cta-button-container">
            <product-prices
              class="main-product__prices-container product-prices__value"
              class-price="text-heading-m text-heading-l-desktop  product-prices__value"
              class-compare-at-price="text-heading-m text-heading-l-desktop"
              :available="variant.available"
              :compare-at-price="variant.compareAtPrice?.amount || liquid.selectedOrFirstAvailableVariant?.compareAtPrice?.amount"
              :price="ctaprice"
              :varies="variant.price?.varies || liquid.selectedOrFirstAvailableVariant?.price?.varies"
              :locationInventory= "variant.id"
              :country ="pagecountry"
              :location="pagelocation"
              :variant=" variant"
              :affirm=false
            />
            <btn
              class="product-form__add-to-cart"
              :label-html="mobileAddToCartText"
              modifiers="primary block center"
              :show-state-icon="state === 'adding'"
              :show-icon="false"
              type="submit"
              @click.prevent="triggerAddToCart"
            />
        </div>
      </div>
    </div>
    <div
      v-if="showStickyMobileAtc"
      class="main-product__mobile-atc"
    >
      <div class="main-product__mobile-atc-header">
        <span
          id="template-title"
          class="
            main-product__title
            text-heading-l
          "
          v-text="product.title || liquid.title"
        />

        <p
          v-if="currentVariantTitle != 'Default Title'"
          class="main-product__title-variant text-body-s-regular"
          v-text="currentVariantTitle"
        />
      </div>
      <btn
        class="product-form__add-to-cart"
        :label-html="`${mobileAddToCartPrice}${mobileAddToCartText}`"
        modifiers="primary block center"
        :show-state-icon="state === 'adding'"
        :show-icon="false"
        type="submit"
        @click.prevent="triggerAddToCart"
      />
    </div>
    <tech-specs
    v-if="product.maxHorsepower || product.boardWidth || product.logDiameter"
      :liquid="liquid"
      :product="product"
      :variant="variant"
      :specimage = specimage
      :specstext="specs"
    />
    <product-details 
     v-if="liquid.type == 'sawmill'"
      :liquid="liquid"
      :product="product"
      :variant="variant"
      :prodimage = product.descriptionImage
      :need-help="contact.needHelp"
    />
    <product-highlights-drawer
      :section-id="sectionId"
      :blocks="highlightBlocks"
    />
  </div>
</template>

<script>

/**
 * Vue: Main product
 * -----------------------------------------------------------------------------
 * Main product page component.
 *
 * @param {Object} liquid - Formatted product Liquid object.
 * @param {Object|Boolean} product - Canvas formatted product object.
 * @param {Object|Boolean} variant - Canvas formatted variant object.
 *
 * @emits updateRequestObject - Emit new product object.
 *
 */
import { mapActions, mapState } from 'vuex'
import ProductForm from '~async/product-form/product-form'
import ProductGallery from '~async/product-gallery/product-gallery'

import MainProductSidebarDetails from './main-product-sidebar-details'
import MainProductSidebarHeader from './main-product-sidebar-header'
import TechSpecs from './tech-specs'
import ProductDetails from './product-details'
import Btn from '~global/btn/btn'

import productQuery from '~graphql/product.gql'
import { formatNoDecimal, formatProduct } from '~/helpers/format'
import { emitUpdateRequestObject } from '~/helpers/vue'
import ProductStat from '~global/product-stat/product-stat'
import ProductHighlightsDrawer from './product-highlights-drawer'
import ProductPrices from '~global/product-prices/product-prices'

export default {
  name: 'MainProduct',

  components: {
    ProductForm,
    ProductGallery,
    MainProductSidebarDetails,
    MainProductSidebarHeader,
    ProductHighlightsDrawer,
    ProductStat,
    TechSpecs,
    ProductDetails,
    Btn,
    ProductPrices,
  },

  props: {
    sectionId: {
      type: String,
      default: '',
    },
    liquid: {
      type: Object,
      default: () => ({
        description: '',
        price: 0,
        title: '',
      }),
    },
    specs: {
      type: String,
      default: 'Specs',
    },
    contact: {
      type: Object,
      default: () => ({
        title: '',
        subCopy: '',
        phone: '',
        buttonText: '',
        buttonUrl: '',
        needHelp: '',
      }),
    },
    product: {
      type:  Object,
      default: () => ({}),
    },
    variant: {
      type: [Boolean, Object],
      default: false,
    },
    uspBlocks: {
      type: [Array],
      default: () => {
        return []
      },
    },
    giftBlocks: {
      type: [Array],
      default: () => {
        return []
      },
    },
    highlightBlocks: {
      type: [Array],
      default: () => {
        return []
      },
    },
    pagecountry :{
      type: String ,
      default:''
    },
    pagelocation :{
      type: String ,
      default:''
    },
    specimage :{
      type: String ,
      default:''
    },
    prodimage :{
      type: String ,
      default:''
    }
  },

  emits: {
    'update-request-object': emitUpdateRequestObject,
  },

  data() {
    return {
      currentIndex: 0,
      currentNamespace: 'gallery',
      handle: cnvs.page.handle,
      state: 'loading',
      isTransactional: false,
      sale: null,
      showStickyMobileAtc: false,
      currentVariantTitle: '',
      attachmentSubtotal: 0,
      techSpecsData: [
        {
          label: this.$string('compare.log_diameter'),
          value: 'logDiameter',
          unit: this.$string('compare.log_diameter_unit'),
          desc: 'logDiameterTooltip',
        },
        {
          label: this.$string('compare.width_of_cut'),
          value: 'widthOfCut',
          unit: this.$string('compare.width_of_cut_unit'),
          desc: 'boardWidthTooltip',
        },

        {
          label: this.$string('compare.max_horsepower'),
          value: 'maxHorsepower',
          unit: this.$string('compare.max_horsepower_unit'),
          desc: 'maxHorsepowerTooltip',
        },
      ],
    }
  },
  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
     * Compute mobile add to cart sticky button text
     */
    mobileAddToCartText() {
      const ctaText = this.$string('product.cta.add_to_cart')
      return `<span class="main-product__mobile-atc-text">${ctaText}</span>`
    },

    /**
     * Compute mobile add to cart sticky button price
     */
    mobileAddToCartPrice() {
      let price = ''
      if (this.variant) {
        const amount = this.variant.price.amount + this.attachmentSubtotal

        price = `<span class="main-product__mobile-atc-text">
          ${formatNoDecimal(this.$formatMoney(amount))}
        </span> <span>|</span>`
      }
      return price
    },
    locInventory(){
      let locinventory = ''
      if (this.variant) {
        locinventory = this.variant.locationInventory
      }
      return locinventory
    },
    ctaprice(){
      let ctaprice = ''
      if (this.variant) {
        const amount = this.variant.price.amount + this.attachmentSubtotal
        //ctaprice = formatNoDecimal(this.$formatMoney(amount))
        ctaprice = this.variant.price.amount + this.attachmentSubtotal
      }
      return ctaprice
    },
    techSpecs() {
      const techSpecs = []

      this.techSpecsData.forEach((spec) => {
        if (this.product[spec.value] || this.liquid[spec.value]) {
          techSpecs.push(spec)
        }
      })

      return techSpecs
    },
  },

  watch: {

    /**
     * Watch handle for update to load new product.
     */
    handle() {
      this.queryProduct(this.handle)
    },
  },

  mounted() {
    this.setProduct()
    this.bindEventListeners()
    if (this.isInView(this.$refs.sidebarWrapper, 'bottom-above')) {
      this.stickyMobileAtc()
    }  

    this.loadall();
    this.addClickToShadowButton();
  },

  methods: {

    
//   loadBreadALA() {
//   
//   let breadAsLowAsContainers = document.getElementsByClassName("bread-as-low-as-container");
//   let breadPlacements = []
//   let setup = {integrationKey: '4ad64e7a-d472-4404-bf33-e7ff260ec543'};
//   for (const container of breadAsLowAsContainers) {
//       let placement = {};
//       let currency = "USD";
//       placement.allowCheckout = false;
//       placement.domID = container.id;
//       placement.order = {};
//       placement.order.items = [];
// 
//       let price = Number(container.dataset.price);
// 
//       placement.order.subTotal = {value: price, currency: currency};
//       placement.order.totalPrice = {value: price, currency: currency};
//       placement.order.currency = currency;
//       placement.order.totalShipping = {value: 0, currency: currency};
//       placement.order.totalTax = {value: 0, currency: currency};
//       placement.order.totalDiscounts = {value: 0, currency: currency};
//       breadPlacements.push(placement);
//     }
//     window.BreadPayments.setup(setup);
//     window.BreadPayments.on('INSTALLMENT:APPLICATION_DECISIONED', () => {});
//     window.BreadPayments.on('INSTALLMENT:APPLICATION_CHECKOUT', () => {});
//     window.BreadPayments.registerPlacements(breadPlacements);
//     window.BreadPayments.__internal__.init();
//   },

 addClickToShadowButton() {
    // Find the bread-button element
    const breadButton = document.getElementsByTagName('bread-button')[0];

    if (breadButton && breadButton.shadowRoot) {
        // Find the button inside the shadow root
        const shadowButton = breadButton.shadowRoot.querySelector('button');

        if (shadowButton) {
            // Add an onclick event listener to the button
            shadowButton.onclick = function () {
              const zoidElements = document.querySelectorAll('[id^="zoid-checkout-component-"]');

                  zoidElements.forEach((element) => {
                    
                      element.remove();
                    
                  });
              // console.log('Shadow DOM button clicked!');
                                
            };
        } else {
            console.warn('Button inside shadow DOM not found.');
        }
    } else {
        console.warn('bread-button or its shadowRoot not found.');
    }
},



   loadall(){
      var merchantId = "203cbdf0-6e71-42f7-bd7d-b7142d767ba1";
        var programId = "2a1d717a-e4ea-43fc-9d2b-6844f06eda79";
        var endpoint = `https://api.platform.breadpayments.com/api/experience/servicing/as-low-as?merchantId=${merchantId}&amount=${this.variant.price?.amount || this.liquid.selectedOrFirstAvailableVariant?.price?.amount}&programId=${programId}`;
        fetch(endpoint)
          .then(response => response.json())
          .then(data => {
            const el = document.getElementById('breadpay-'+this.variant.id|| this.liquid.selectedOrFirstAvailableVariant?.id);
            el.innerHTML = ' <div class="btn_layout"><span>AS LOW AS </span> <span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103 40" fill="%2313294B" height="30" width="50"><title>Bread</title><path d="m53.111 18.526c-2.0394 0-3.5201 0.7543-4.5258 2.0395v-1.6483h-3.604v19.556h3.604v-7.2358c1.0057 1.2852 2.4864 2.0395 4.5258 2.0395 3.7436 0 6.8169-3.2128 6.8169-7.3755s-3.0733-7.3755-6.8169-7.3755zm-0.6705 11.315c-2.207 0-3.8553-1.5924-3.8553-3.9392 0-2.3467 1.6483-3.9392 3.8553-3.9392 2.235 0 3.8836 1.5925 3.8836 3.9392 0 2.3468-1.6486 3.9392-3.8836 3.9392zm20.645-10.924v1.6483c-1.0061-1.2572-2.5144-2.0395-4.5539-2.0395-3.7155 0-6.7889 3.2128-6.7889 7.3755s3.0734 7.3755 6.7889 7.3755c2.0395 0 3.5478-0.7823 4.5539-2.0395v1.6483h3.6039v-13.969h-3.6039zm-3.8833 10.924c-2.2072 0-3.8556-1.5924-3.8556-3.9392 0-2.3467 1.6484-3.9392 3.8556-3.9392 2.235 0 3.8833 1.5925 3.8833 3.9392 0 2.3468-1.6483 3.9392-3.8833 3.9392zm19.863-10.924-3.1011 9.3869-3.6317-9.3869h-3.9395l5.7273 13.522c-0.6706 1.8719-1.6761 2.71-3.66 2.682v3.3525c3.5483 0.1956 5.9227-1.5645 7.3755-5.5875l5.085-13.969h-3.8555z"/><path d="m95.975 30.556h-2.0861v0.3273h0.8511v2.2756h0.38v-2.2756h0.855v-0.3273z"/><path d="m99.062 30.556h-0.4339l-0.9172 1.3758-0.9212-1.3758h-0.4338v2.6029h0.3844v-2.0302l0.9461 1.4129h0.0495l0.9461-1.4167v2.034h0.38v-2.6029z"/><path d="m50.423 6.5287c-1.1242 0-1.9404 0.41584-2.4949 1.1242v-3.9887h-1.9866v10.78h1.9866v-0.9086c0.5545 0.7083 1.3707 1.1242 2.4949 1.1242 2.0636 0 3.7577-1.7711 3.7577-4.0657 0-2.2947-1.6941-4.0657-3.7577-4.0657zm-0.3696 6.2372c-1.2167 0-2.1253-0.8779-2.1253-2.1715 0-1.2937 0.9086-2.1714 2.1253-2.1714 1.232 0 2.1406 0.87778 2.1406 2.1714 0 1.2936-0.9086 2.1715-2.1406 2.1715zm7.5147-4.6972v-1.3244h-1.9861v7.7002h1.9861v-3.6807c0-1.6171 1.3095-2.0791 2.3411-1.9558v-2.2177c-0.97 0-1.9405 0.43122-2.3411 1.4784zm4.8961 3.3419h5.8056c0.0461-0.2618 0.0772-0.5236 0.0772-0.8162 0-2.2639-1.6172-4.0657-3.8961-4.0657-2.4183 0-4.0661 1.7711-4.0661 4.0657 0 2.2946 1.6328 4.0657 4.22 4.0657 1.4783 0 2.6333-0.6006 3.3572-1.6479l-1.6017-0.924c-0.3388 0.4467-0.955 0.77-1.725 0.77-1.0472 0-1.8938-0.4312-2.1711-1.4476zm-0.0311-1.54c0.2311-0.98561 0.955-1.5554 2.0178-1.5554 0.8311 0 1.6628 0.44661 1.9094 1.5554h-3.9272zm13.093-3.1263v0.90861c-0.5544-0.693-1.3861-1.1242-2.5106-1.1242-2.0483 0-3.7422 1.7711-3.7422 4.0657 0 2.2946 1.6939 4.0657 3.7422 4.0657 1.1245 0 1.9562-0.4312 2.5106-1.1242v0.9086h1.9867v-7.7002h-1.9867zm-2.1406 6.0216c-1.2166 0-2.1255-0.8779-2.1255-2.1715 0-1.2937 0.9089-2.1714 2.1255-2.1714 1.2317 0 2.1406 0.87778 2.1406 2.1714 0 1.2936-0.9089 2.1715-2.1406 2.1715zm11.765-9.1016v3.9887c-0.5544-0.70839-1.3705-1.1242-2.4944-1.1242-2.0639 0-3.7578 1.7711-3.7578 4.0657 0 2.2946 1.6939 4.0657 3.7578 4.0657 1.1239 0 1.94-0.4159 2.4944-1.1242v0.9086h1.9867v-10.78h-1.9867zm-2.125 9.1016c-1.2322 0-2.1405-0.8779-2.1405-2.1715 0-1.2937 0.9083-2.1714 2.1405-2.1714 1.2167 0 2.125 0.87778 2.125 2.1714 0 1.2936-0.9083 2.1715-2.125 2.1715z"/><path d="m19.435 1.0216c-10.734 0-19.435 8.7002-19.435 19.435 0 10.734 8.7002 19.435 19.435 19.435 10.734 0 19.435-8.7003 19.435-19.435 0.0182-10.734-8.682-19.435-19.435-19.435zm3.7416 33.584-0.2542 0.1454c-1.7074 0.9263-3.8507 0.2724-4.777-1.4349l-10.571-19.635c-0.92633-1.7073-0.27244-3.8506 1.4349-4.7769l0.25428-0.14528c1.7073-0.92633 3.8506-0.29061 4.7769 1.4349l10.571 19.634c0.9081 1.7255 0.2724 3.8506-1.435 4.7769zm4.2684-5.4489-8.2098-15.239c4.2139-2.2705 9.4631-0.6903 11.734 3.5236 2.2704 4.1958 0.6902 9.4449-3.5237 11.715z"/></svg> </span> </div> <p class="btn_price">' + data.asLowAs.paymentAmountText["en-us"] + ' / MONTH <span id="financing-disclosure">*</span></p>';
          })
          .catch(error => {
            //console.log(error);
          });
  },

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
    }),

    /**
     * Get variant or liquid first selected variant.
     */
    getVariantOrLiquidFirstSelectedVariant() {
      return this.variant || this.liquid.selectedOrFirstAvailableVariant
    },

    /**
     * Handle attachment subtotal update
     * @param {Number} amount - attachment add-on subtotal
     */
    handleAttachmentSubtotalUpdate(amount) {
      this.attachmentSubtotal = amount
    },

    /**
     * Check if element container is in view
     *
     * @param {Element} container - element container
     * @param {String} position - check if top, bottom, bottom-above
     * or both of screen
     *
     */
    isInView(container, position) {
      const windowHeight = window.innerHeight
      const elementRectangle = container.getBoundingClientRect()
      const elementTop = elementRectangle.top
      const elementBottom = elementRectangle.bottom
      const topInView = (elementTop > 0) && (elementTop < windowHeight)
      const bottomInView = (elementBottom > 0) && (elementBottom < windowHeight)
      const bottomIsAbove = elementBottom < 0
      if (position === 'top' && topInView) {
        return true
      }

      if (position === 'bottom' && bottomInView) {
        return true
      }

      if (position === 'both' && topInView && bottomInView) {
        return true
      }

      if (position === 'bottom-above' && bottomIsAbove) {
        return true
      }

      return false
    },

    /**
     * Show sticky add to cart button on mobile
     */
    stickyMobileAtc() {
    
        this.showStickyMobileAtc = true
    },

    /**
     * Hide sticky add to cart button on mobile
     */
    unStickyMobileAtc() {
      this.showStickyMobileAtc = false
    },

    /**
     * Bind Event listeners
     */
    bindEventListeners() {
      document.addEventListener('scroll', () => {
        const position = window.scrollY

        if (this.isInView(this.$refs.productFormWrapper, 'bottom-above')) {
          this.stickyMobileAtc()
        }

        if (this.isInView(this.$refs.productFormWrapper, 'bottom')) {
          this.unStickyMobileAtc()
        }

        if (position === 0) {
          this.unStickyMobileAtc()
        }
      })
    },

    /**
     * Set Liquid product object to product.
     */
    setProduct() {
      if (!this.liquid.handle) {
        this.queryProduct()
        return
      }

      this.$emit('update-request-object', {
        response: this.liquid,
        type: 'product',
      })

      this.state = 'ready'
    },

    /**
     * Loads product from GraphQL.
     * @param {String} [handle] - Product handle to load.
     */
    async queryProduct(handle = this.handle) {
      if (handle === false || this.product.handle === handle) {
        return
      }

      this.state = 'loading'

      try {
        const response = await cnvs.Query({
          query: productQuery,
          variables: {
            country: cnvs.store.country,
            handle,
            language: cnvs.store.language,
          },
        })

        if (cnvs.settings.disableComponentReadyState) {
          return
        }

        this.$emit('update-request-object', {
          response: formatProduct(response),
          type: 'product',
        })

        this.state = 'ready'

      } catch (error) {
        cnvs.ReportError('Failed to load product', error)
      }
    },

    /**
     * Update current carousel index.
     * @param {Number} newIndex - New carousel index.
     */
    handleUpdateCurrentIndex(newIndex) {
      if (newIndex === this.currentIndex) {
        return
      }

      this.currentIndex = newIndex
    },

    /**
     * Update current carousel namespace.
     * @param {String} newNamespace - New carousel namespace.
     */
    handleUpdateCurrentNamespace(newNamespace) {
      this.currentNamespace = newNamespace
    },

    /**
     * Handle variant update from product form.
     * @param {Object} variant - Selected variant.
     */
    handleVariantUpdate(variant) {
      this.$emit('update-request-object', {
        response: variant,
        type: 'variant',
      })

      const params = new URLSearchParams(document.location.search.substring(1))

      if (variant?.id) {
        params.set('variant', variant.id)
      }

      const url = variant?.id
        ? `${location.origin}${location.pathname}?${params.toString()}`
        : `${location.origin}${location.pathname}`

      history.replaceState({
        html: '',
      }, '', url)

      this.currentVariantTitle = variant.title
    },

    /**
     * Handle mobile add to cart click
     */
    handleMobileAtcClick() {
      cnvs.EventBus.emit('add-to-cart')
    },

    /**
     * Handle mobile add to cart click
     * TODO: Use for review.io
     */
    scrollToReview() {
      const reviews = document.querySelector('#ReviewsWidget')

      if (!reviews) {
        return
      }

      reviews.scrollIntoView({ behavior: 'smooth' })
    },

    /**
     * Trigger add to cart
     */
    triggerAddToCart() {
      this.$refs.productForm.handleAddToCart()
    },
  },
}
</script>

<style lang="scss">
@import '~async/product-gallery-modal/product-gallery-modal-overlay';
@import './main-product';
@import './product-highlights';
@import '@/components/reviews-io';
</style>
